import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c(VIcon,{staticClass:"iconSection"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('div',{staticClass:"descriptionSection"},[_vm._t("description",function(){return [_vm._v(" "+_vm._s(_vm.description)+" ")]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }